module.exports = __webpack_public_path__ + "img/interactive-hero-slider-infiniti.f7e6476a.png";